/*
 * @Description: 时间下拉选择框
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-04-19 14:20:57
 * @LastEditTime: 2019-04-25 15:22:45
 */
import React from 'react'
import PropTypes from 'prop-types'
import Calendar from '../Calendar/Calendar';

export default class TimeInput extends React.Component {

  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string
  }

  constructor (props) {
    super(props)

    this.state = {
      _this: null,
      visible: false,
      time: this.props.value
    }

    this.change = this.change.bind(this)
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
  }


  componentDidMount () {
    this.setState({
      _this: this.refs.wrapper
    })
    // 注册事件
    document.addEventListener('click', this.close)
  }

  /**
   * 销毁绑定的事件
   */
  componentWillUnmount () {
    document.removeEventListener('click', this.close)
  }

  /**
   * 打开弹出框
   * @param {*} e 
   */
  open (e) {
    e.nativeEvent.stopImmediatePropagation();
    this.setState({
      visible: true
    })
  }

  /**
   * 关闭弹出
   * @param {Event} e 
   */
  close (e) {
    e.stopPropagation()
    const _this = this.state._this

    if (!_this.contains(e.target)) {
      this.setState({
        visible: false
      })
    }
  }

  /**
   * 文本框改变，传递给父组件数据并隐藏
   * @param {String} val 
   */
  change (val) {
    const change = this.props.onChange
    typeof change ==='function' && change(val)
    this.setState({
      time: val,
      visible: false
    })
  }

  render () {
    let {value, onChange, ...props} = this.props
    value = value || this.state.time
    return (
      <div ref="wrapper" style={{
        position: 'relative',
        display: 'inline-block'
      }}>
        <input type="text" {...props} onClick={this.open} value={value} />
        <Calendar
          isShow={this.state.visible}
          close={this.change}
          cycle='日榜'
          en={() => {this.setState({
            beginTimeShow: true
          })}}
          ov={() => {this.setState({
            beginTimeShow: false
          })}}
          otherlayout={true}
        />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// src/components/TimeInput/TimeInput.js